<template>
    <div class="competition-record">
        <div class="search-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item label="单位名称">
                    <el-input v-model="queryParams.unitName" placeholder="请输入单位名称" size="small" />
                </el-form-item>
                <el-form-item label="赛事名称">
                    <el-input v-model="queryParams.matchName" placeholder="请输入赛事名称" size="small" />
                </el-form-item>
                <el-form-item label="报名状态">
                    <el-select v-model="queryParams.signUpStatus" placeholder="请选择报名状态" style="width: 200px"
                        size="small">
                        <el-option v-for="item in statusOptions.filter(a => a.value < 3)" :key="item.value"
                            :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="clickQueryBtn" size="small">查询</el-button>

                    <!-- <el-button @click="resetQuery" size="small">重置</el-button> -->
                </el-form-item>
            </el-form>
        </div>

        <div class="table-container">
            <el-table :data="tb.data" v-loading="loading" style="width: 100%" size="small" border>
                <el-table-column prop="UnitName" label="单位名称" />
                <el-table-column prop="MatchName" label="赛事名称" />
                <el-table-column label="分组" prop="GroupName" align="center">
                    <template #default="scope">
                        {{ scope.row.GroupName }}
                        ({{ scope.row.IsSuper == 1 ? '超级组' : '普通组' }})
                    </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="报名时间" align="center">
                    <template #default="scope">
                        {{ formatDate(scope.row.CreateTime) }}
                    </template>
                </el-table-column>
                <el-table-column prop="AthleteCount" label="运动员人数" align="center" width="100" />
                <el-table-column prop="TeamLeaderCount" label="随队人员人数" width="100" align="center" />
                <el-table-column label="回执" align="center">
                    <template v-slot="scope">
                        <el-button type="text" @click="showUploadReceiptDialog(scope.row)">上传/查看({{
                            scope.row.ReceiptFileIds == '' ? 0 :
                                scope.row.ReceiptFileIds.split(',').length }})</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="报名状态" align="center">
                    <template #default="scope">
                        <el-tag size="small" :type="getStatusType(scope.row.SignUpStatus)">
                            {{ getStatusText(scope.row.SignUpStatus) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="AuditResult" label="审核结果" align="center" />
                <el-table-column label="操作" align="center" width="180">
                    <template #default="scope">
                        <el-tooltip size="mini" content="设置随单人员" placement="bottom" effect="light"
                            v-if="scope.row.SignUpStatus == 1">
                            <el-button icon="el-icon-edit" size="mini" @click="setFollowDialog(scope.row)"
                                circle></el-button>
                        </el-tooltip>
                        <el-tooltip size="mini" content="报名表" placement="bottom" effect="light">
                            <el-button icon="el-icon-baomingbiao" size="mini" @click="viewDetails(scope.row)"
                                circle></el-button>
                        </el-tooltip>
                        <el-tooltip size="mini" content="打印" placement="bottom" effect="light">
                            <el-button icon="el-icon-lianxi2hebing_dayin" size="mini" @click="printForm(scope.row)"
                                circle></el-button>
                        </el-tooltip>
                        <el-tooltip size="mini" content="通过" placement="bottom" effect="light">
                            <el-button icon="el-icon-tongguo" size="mini" type="success"
                                v-if="scope.row.SignUpStatus == 0" @click="auditPass(scope.row)" circle></el-button>
                        </el-tooltip>
                        <el-tooltip size="mini" content="驳回" placement="bottom" effect="light">
                            <el-button icon="el-icon-bohui" size="mini" type="danger" v-if="scope.row.SignUpStatus == 0"
                                @click="auditReject(scope.row)" circle></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="tb.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="tb.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="tb.total" />
            </div>
        </div>

        <el-dialog :visible.sync="showFormVisible" top="30px" width="1000px">
            <div style="margin: 0 auto;">
                <MatchSignResult :signData="signFormDetail" v-if="signFormDetail"></MatchSignResult>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" size="small" v-if="signFormDetail && signFormDetail.SignUpStatus == 0"
                    @click="auditPass(signFormDetail)">通 过</el-button>
                <el-button type="danger" size="small" v-if="signFormDetail && signFormDetail.SignUpStatus == 0"
                    @click="auditReject(signFormDetail)">驳 回</el-button>
                <el-button type="danger" size="small" v-if="signFormDetail && signFormDetail.SignUpStatus == 1"
                    @click="auditCancel(signFormDetail)">撤回审核</el-button>
                <el-button size="small" @click="showFormVisible = false">取 消</el-button>

                <!-- <el-button type="primary" @click="printForm">打 印</el-button> -->
            </span>
        </el-dialog>
        <el-dialog title="比赛成绩" :visible.sync="showScoreVisible" width="1000px">
            <el-table :data="score" border>
                <el-table-column label="分组" prop="GroupName" align="center"></el-table-column>
                <el-table-column label="项目名" prop="ProjectName" align="center" width="200"></el-table-column>
                <el-table-column label="项目类型" prop="ProjectTypeName" align="center"></el-table-column>
                <el-table-column label="姓名" prop="UserName" align="center"></el-table-column>
                <el-table-column label="状态" prop="Status" align="center">
                    <template v-slot="scope">
                        <span v-if="scope.row.Status == 0">待上场</span>
                        <span v-if="scope.row.Status == 1">准备区</span>
                        <span v-if="scope.row.Status == 2">比赛中</span>
                        <span v-if="scope.row.Status == 3">已比赛</span>
                        <span v-if="scope.row.Status == 4">弃权</span>
                    </template>
                </el-table-column>
                <el-table-column label="成绩" prop="Score" align="center"></el-table-column>
                <el-table-column label="得分" prop="TotalPoints" align="center"></el-table-column>
                <el-table-column label="名次" prop="Ranking" align="center"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showScoreVisible = false" size="small">取 消</el-button>
                <!-- <el-button type="primary" @click="printForm">打 印</el-button> -->
            </span>
        </el-dialog>
        <el-dialog title="回执上传" :visible.sync="uploadReceiptDialogVisible" width="1000px">
            <div class="teamPhoto" style="padding-top: 20px;box-sizing: border-box;text-align: center;">
                <el-upload action="#" list-type="picture-card" :on-preview="handlePictureCardPreview"
                    :http-request="(file) => uploadFile(file, 'receiptPhoto')" :file-list="fileList"
                    :on-remove="handleRemove" :on-exceed="handleExceed" accept=".jpg,.png,.jpeg" :limit="5" multiple>
                    <i class="el-icon-plus"></i>
                </el-upload>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="setMatchSignUpFormReceiptFileIds">提 交</el-button>
                <el-button @click="uploadReceiptDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="imageDialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="设置随单人员" :visible.sync="setFollowDialogVisible" width="1000px">
            <el-table ref="multipleTable2" :data="unitTeamLeaders" border 
            :row-key="getRowKey" size="small"
             @selection-change="handleStaffTableSelectionChange">
                <el-table-column type="selection" width="55" align="center">
                </el-table-column>
                <el-table-column label="姓名" prop="StaffName" align="center"></el-table-column>
                <el-table-column label="性别" prop="Gender" align="center">
                    <template v-slot="scope">
                        <span v-if="scope.row.Gender == 0">男</span>
                        <span v-if="scope.row.Gender == 1">女</span>
                    </template>
                </el-table-column>
                <el-table-column label="年龄" prop="Age" align="center"></el-table-column>
                <el-table-column label="身份证号码" prop="IdentityCard" align="center" width="200"></el-table-column>
                <el-table-column label="出生日期" prop="StaffName" align="center">
                    <template v-slot="scope">
                        {{ scope.row.Birthday ? formatBirthday(scope.row.Birthday) : '' }}
                    </template>
                </el-table-column>
                <el-table-column label="手机号码" prop="StaffPhone" align="center"></el-table-column>
                <el-table-column label="身份" prop="Post" align="center"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="submitSignUpFormTeamLeaders">提 交</el-button>
                <el-button size="small" @click="setFollowDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import contestantServices from '../../../request-server/request-services/contestant-services';
import systemService from '@/request-server/request-services/system-services.js';
import matchServices from '../../../request-server/request-services/match-services';
import utilsCommon from '@/utils/utils-common';
import MatchSignResult from '@/components/common/match-sign-result.vue';
import Url from '@/request-server/request-url';
import Axios from "axios";
export default {
    name: 'CompetitionRecord',
    components: {
        MatchSignResult
    },
    data() {
        return {
            fileRootPath: '',
            loading: false,
            showFormVisible: false,
            showScoreVisible: false,
            tb: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
                data: null
            },
            signFormDetail: null,
            print: false,
            score: [],
            // 查询参数
            queryParams: {
                unitName: '',
                matchName: '',
                signUpStatus: '',
            },
            // 状态选项
            statusOptions: [
                { value: -1, label: '全部' },
                { value: 0, label: '审核中' },
                { value: 1, label: '已通过' },
                { value: 2, label: '未通过' },
                { value: 3, label: '撤回' },
                { value: 4, label: '覆盖、失效' },
                { value: 5, label: '草稿' },
                // { value: 3, label: '已撤回' }
            ],
            uploadReceiptDialogVisible: false,
            uploadReceiptFormId: '',
            uploadReceiptFileIds: [],
            imageDialogVisible: false,
            dialogImageUrl: '',
            fileList: [],
            setFollowDialogVisible: false,
            setFollowFormId: '',
            unitTeamLeaders: [],
            staffTableSelection:[],
        };
    },
    created() {
        this.fetchRecords();
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/'
    },
    methods: {
        clickQueryBtn() {
            this.queryParams.pageNum = 1;
            this.fetchRecords();
        },
          getRowKey(row) {
            return row.TeamLeaderId;
        },
         handleStaffTableSelectionChange(val) {
            console.log(val);
            this.staffTableSelection = val;
        },

        // 获取报名记录数据
        async fetchRecords() {
            this.loading = true;

            const param = {
                PageIndex: this.tb.pageNum,
                PageSize: this.tb.pageSize,
                Where: {
                    Terminal: "admin",
                    MatchName: this.queryParams.matchName,
                    UnitName: this.queryParams.unitName,
                    SignUpStatus: this.queryParams.signUpStatus == -1 ? '' : this.queryParams.signUpStatus
                }
            };

            try {
                this.records = [];
                const res = await matchServices.selectSignUpForms(param);
                if (res.code == 0) {
                    this.tb.data = res.data.Data;
                    this.tb.total = res.data.TotalRow;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        // 处理每页显示数量变化
        handleSizeChange(size) {
            this.tb.pageSize = size;
            this.fetchRecords();
        },
        // 处理页码变化
        handleCurrentChange(page) {
            this.tb.pageNum = page;
            this.fetchRecords();
        },
        // 获取状态对应的文本
        getStatusText(status) {
            const option = this.statusOptions.find(item => item.value === status);
            return option ? option.label : '未知状态';
        },
        // 获取状态对应的类型
        getStatusType(status) {
            const typeMap = {
                0: 'primary',  // 审核中 - 蓝色
                2: 'warning',  // 已通过 - 绿色
                1: 'success',  // 不通过 - 黄色
            };
            return typeMap[status] || 'info';
        },
        formatDate(date) {
            return utilsCommon.formatDate(date);
        },
        // 查看详情
        viewDetails(record) {
            // 跳转到详情页或打开详情弹窗
            contestantServices.getUnitMatchSignUpForm({ formId: record.SignUpFormId })
                .then(resData => {
                    console.log(resData);
                    if (resData.code == 0) {
                        this.signFormDetail = resData.data;
                        if (this.signFormDetail.UnitAthletes) {
                            this.signFormDetail.UnitAthletes.forEach(element => {
                                if (element.AllFilePaths) {
                                    for (let index = 0; index < element.AllFilePaths.length; index++) {
                                        element.AllFilePaths[index] = this.fileRootPath + element.AllFilePaths[index];
                                    }
                                }
                            });
                        }
                        console.log(this.signFormDetail)
                        this.showFormVisible = true;
                    }
                })
                .finally(() => { });
        },
        viewScores(row) {
            contestantServices.getUnitMatchScore({ signUpFormId: row.SignUpFormId })
                .then(resData => {
                    console.log(resData);
                    if (resData.code == 0) {
                        this.score = resData.data;
                        this.showScoreVisible = true;
                    }
                })
                .finally(() => { });
        },
        setFollowDialog(data) {
            this.setFollowFormId = data.SignUpFormId;
            this.setFollowDialogVisible = true;
            this.staffTableSelection = [];

            Axios.all([
                contestantServices.getUnitMatchSignUpForm({ formId: data.SignUpFormId }),
                matchServices.selectUnitAllTeamLeaders({ unitId: data.UnitId }),

            ])
                .then(
                    Axios.spread((signFormDetailRes, teamLeaderRes) => {
                        if (teamLeaderRes.code == 0 && signFormDetailRes.code == 0) {
                            this.unitTeamLeaders = teamLeaderRes.data.Data;
                            this.signFormDetail = signFormDetailRes.data;
                            let selectedRows = [];
                            for (let i = 0; i < this.signFormDetail.UnitTeamLeaders.length; i++) {
                                selectedRows.push(this.signFormDetail.UnitTeamLeaders[i].TeamLeaderId);
                            }
                            console.log(this.unitTeamLeaders);
                            setTimeout(() => {
                                this.$nextTick(() => {

                                    for (let i = 0; i < selectedRows.length; i++) {
                                        console.log(selectedRows[i]);
                                        let row = this.unitTeamLeaders.find(item => item.TeamLeaderId === selectedRows[i]);
                                        console.log("row:", row);
                                        this.$refs.multipleTable2.toggleRowSelection(row, true);

                                    }
                                });
                            }, 500);
                        }
                    }))




        },
        submitSignUpFormTeamLeaders(){
            if(this.staffTableSelection.length == 0){
                this.$message({
                    message: '请选择随队人员',
                    type: 'warning'
                });
                return;
            }

            let data = {
                SignUpFormId: this.setFollowFormId,
                TeamLeaderIds: this.staffTableSelection.map(item => item.TeamLeaderId)
            }

            matchServices.submitSignUpFormTeamLeaders(data).then(resData => {
                if (resData.code == 0) {
                    this.$message({
                        message: '随队人员更新成功',
                        type: 'success'
                    });
                    this.$refs.multipleTable2.clearSelection();
                    this.fetchRecords();
                    this.staffTableSelection = [];
                    this.unitTeamLeaders = [];
                    this.setFollowFormId = '';
                    this.setFollowDialogVisible = false;
                }
            })

        },
        printForm(record) {
            let newWindowWidth = window.screen.availWidth * 0.8;
            let newWindowHeight = window.screen.availHeight * 0.9;
            //跳转到打印预览页面
            window.open(
                `${window.location.origin}/#/sign-up-form-print/${record.SignUpFormId}`,
                "",
                `location=no,height=${newWindowHeight},width=${newWindowWidth}`
            );
        },
        auditReject(row) {
            this.$prompt('请输入驳回理由', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                let data = {
                    status: 2,
                    formId: row.SignUpFormId,
                    reason: value
                }
                this.sumbitAudit(data);
            })
        },
        auditPass(row) {
            this.$confirm('是否确认通过该报名表?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    status: 1,
                    formId: row.SignUpFormId,
                    reason: '审核通过'
                }
                this.sumbitAudit(data);
            })
        },

        auditCancel(row) {
            this.$confirm('是否确认要取消审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    status: 3,
                    formId: row.SignUpFormId,
                    reason: '取消申请'
                }
                this.sumbitAudit(data);
            })
        },
        sumbitAudit(data) {
            console.log(data)
            matchServices.auditSignUpForm(data).then(resData => {
                if (resData.code == 0) {
                    this.$message.success(resData.data);
                    if (this.showFormVisible) {
                        this.viewDetails({ SignUpFormId: data.formId });
                    }

                    this.fetchRecords();
                }
            })
        },
        showUploadReceiptDialog(row) {
            this.uploadReceiptFormId = row.SignUpFormId;
            this.fileList = [];
            this.uploadReceiptFileIds = [];
            if (row.ReceiptFileIds) {
                this.uploadReceiptFileIds = row.ReceiptFileIds.split(',');
                row.ReceiptFilePaths.forEach(p => {
                    this.fileList.push({
                        name: '',
                        url: this.fileRootPath + p
                    });
                })

            }
            console.log(this.uploadReceiptFileIds)

            this.uploadReceiptDialogVisible = true;

        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.imageDialogVisible = true;
        },
        handleRemove(file) {
            // 从 fileList 中找到要删除的文件的索引
            const fileIndex = this.fileList.findIndex(item => item.url === file.url);
            if (fileIndex > -1) {
                // 从 fileList 中移除该文件
                this.fileList.splice(fileIndex, 1);
                this.uploadReceiptFileIds.splice(fileIndex, 1);
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最多只能上传 5 张图片`);
        },

        uploadFile(options, fileType) {
            const file = options.file;
            const formData = new FormData();
            formData.append('files', file);
            formData.append('desc', 'sign-up-files');
            formData.append('type', 'sign-up-files');
            console.log(this.uploadReceiptFileIds)
            systemService.uploadFiles(formData).then(res => {
                if (res.code == 0) {
                    res.data.forEach(fileItem => {
                        let uploadFile = fileItem;
                        this.uploadReceiptFileIds.push(uploadFile.FileId);
                        this.uploadReceiptFiles.push(uploadFile);
                        this.fileList.push({
                            name: uploadFile.FileName,
                            url: this.fileRootPath + uploadFile.SaveFolder + '/' + uploadFile.FileId + uploadFile.FileSuffix
                        });
                    });
                    console.log(this.uploadReceiptFileIds)

                    this.$message.success('上传成功');
                }
            });
        },

        setMatchSignUpFormReceiptFileIds() {
            let data = {
                formId: this.uploadReceiptFormId,
                fileIds: this.uploadReceiptFileIds.join(',')
            }
            contestantServices.setMatchSignUpFormReceiptFileIds(data).then(resData => {
                if (resData.code == 0) {
                    this.$message.success(resData.data);
                    this.fetchRecords();
                    this.uploadReceiptDialogVisible = false;
                }
            })
            console.log(data)
        },
        formatBirthday(dateTimeStr) {
            console.log(dateTimeStr);
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            if (dateTimeStr.indexOf('T') > -1) return dateTimeStr.split('T')[0];
            return dateTimeStr.split(' ')[0];
        },
    }
};
</script>

<style scoped>
.competition-record {
    margin: 0 auto;
    padding: 16px;
    box-sizing: border-box;
    background: #fff;
}

.search-container {
    border-radius: 4px;
}

.table-container {
    border-radius: 4px;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
}
</style>
